module.exports = __webpack_public_path__ + "img/APPCode.b2fbc249.png";